package br.com.texeratx.boardgametimeapp.ui.utils

fun formatPhoneForDisplay(phone: String?): String? {
    val raw = phone?.trim().orEmpty()
    if (raw.isBlank()) return null

    val digits = raw.filter { it.isDigit() }
    if (digits.length < 10) return raw

    val local = when {
        digits.startsWith("55") && digits.length >= 12 -> digits.substring(2)
        else -> digits
    }

    return when (local.length) {
        11 -> "+55 (${local.substring(0, 2)}) ${local.substring(2, 7)}-${local.substring(7, 11)}"
        10 -> "+55 (${local.substring(0, 2)}) ${local.substring(2, 6)}-${local.substring(6, 10)}"
        else -> raw
    }
}
